define('cartware/utils/image/preload',[
	"../../objectpool/image"
], function(
	ImagePool
) {
	var pool = ImagePool.getInstance();

	function preload(src, cb) {
		var image = pool.alloc();

		image.onload = function() {
			var info = { width: image.width, height: image.height};
			pool.release(image);
			cb(null, info);
		};

		image.onerror = function() {
			pool.release(image);
			cb(new Error("Image with source \"" + src + "\" could not be loaded."));
		};

		image.src = src;
	}

	return preload;
});
